import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sanitizeReturnTo } from '../../auth/returnTo';
import { confirmPayment } from '../../payments/client';
import { getPaymentAnalyticsContext, trackEvent, trackConfirmedPurchase } from '../../utils/analytics';

const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0f172a',
    color: '#fff',
    padding: '2rem',
    textAlign: 'center',
};

export default function PaymentSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState('Confirming your payment...');

    useEffect(() => {
        let cancelled = false;

        async function run() {
            const paymentKey = searchParams.get('paymentKey');
            const orderId = searchParams.get('orderId');
            const amount = Number.parseInt(searchParams.get('amount') || '', 10);

            if (!paymentKey || !orderId || !Number.isInteger(amount) || amount <= 0) {
                trackEvent('payment_failed', {
                    currency: 'KRW',
                    value: Number.isInteger(amount) ? amount : undefined,
                    payment_provider: 'toss',
                    failure_reason: 'verification_failed', failure_stage: 'confirmation', error_type: 'verification_failed',
                });
                navigate('/payments/fail?message=Missing%20payment%20confirmation%20data&analytics_tracked=1', { replace: true });
                return;
            }

            try {
                const result = await confirmPayment(paymentKey, orderId, amount);
                if (cancelled) return;
                if (result.status !== 'confirmed') throw new Error('payment_not_confirmed');
                trackConfirmedPurchase(result, {
                    currency: 'KRW',
                    value: amount,
                    payment_provider: 'toss',
                    market: 'KR',
                    product_id: result.product_id,
                    ...getPaymentAnalyticsContext(result.product_id),
                    items: [{
                        item_id: result.product_id,
                        item_name: result.product_id,
                        price: amount,
                        quantity: 1,
                    }],
                });
                window.dispatchEvent(new Event('premium-entitlements-updated'));
                const queryReturnTo = searchParams.get('returnTo') || '';
                const nextPath = sanitizeReturnTo(result.return_to || queryReturnTo || result.route || '', '/mypage');
                navigate(nextPath, { replace: true });
            } catch (err) {
                if (cancelled) return;
                trackEvent('payment_failed', {
                    currency: 'KRW',
                    value: amount,
                    payment_provider: 'toss',
                    failure_reason: Number(err?.status) === 0 ? 'network_error' : 'verification_failed',
                    failure_stage: 'confirmation',
                    error_type: Number(err?.status) === 0 ? 'network_error' : 'verification_failed',
                });
                setMessage(err.message || 'Payment confirmation failed.');
                setTimeout(() => {
                    navigate(`/payments/fail?message=${encodeURIComponent(err.message || 'Payment confirmation failed')}&analytics_tracked=1`, { replace: true });
                }, 800);
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [navigate, searchParams]);

    return (
        <div style={containerStyle}>
            <div>
                <h1 style={{ marginBottom: '1rem' }}>Payment success</h1>
                <p style={{ color: '#cbd5e1' }}>{message}</p>
            </div>
        </div>
    );
}
